import { render, staticRenderFns } from "./restaurant-finance.vue?vue&type=template&id=59ffa7fd&"
import script from "./restaurant-finance.vue?vue&type=script&lang=js&"
export * from "./restaurant-finance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports